// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"91a48acf","496":"750bb36a","742":"d2e13c7e","925":"f90ffe39"}[chunkId] + ".chunk.js";
};